<template>
    <div class="super-admin-panel">
        <section class="card super-admin-card">
            <div class="super-admin-header">
                <div class="super-admin-heading">
                    <span class="super-admin-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                            stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
                            <path d="M9 12l2 2 4-4" />
                        </svg>
                    </span>
                    <div>
                        <h2>Gestion Super Admin</h2>
                        <p>Administration de la balise</p>
                    </div>
                </div>
                <span class="super-admin-access">Réservé aux admins Argos</span>
            </div>

            <div class="super-admin-fields">
                <div class="super-admin-field">
                    <span class="super-admin-label">Client</span>
                    <strong class="super-admin-value">{{ balise.client ? balise.client.name : 'Non renseigné' }}</strong>
                </div>
                <div class="super-admin-field">
                    <span class="super-admin-label">IMEI</span>
                    <strong class="super-admin-value"><IMEIDisplay :imei="balise.imei" /></strong>
                </div>
                <div class="super-admin-field">
                    <span class="super-admin-label">Code transmetteur Atlant</span>
                    <strong class="super-admin-value">{{ balise.atlantId || 'Non renseigné' }}</strong>
                </div>
            </div>

            <nav class="super-admin-actions" aria-label="Actions d'administration de la balise">
                <router-link :to="'/balise/admin/editbalise/' + balise.id">
                    Modifier la balise
                    <span aria-hidden="true">→</span>
                </router-link>
                <router-link :to="'/balise/admin/alarmtypeconfigs/' + balise.id">
                    Config alarmes
                    <span aria-hidden="true">→</span>
                </router-link>
                <router-link :to="'/balise/admin/digitalio/' + balise.id">
                    Config Digital I/O
                    <span aria-hidden="true">→</span>
                </router-link>
            </nav>
        </section>
    </div>
</template>

<script>
import IMEIDisplay from '@/components/display/IMEIDisplay.vue'

export default {
    props: ['balise'],
    components: {
        IMEIDisplay,
    },
}
</script>

<style scoped>
.super-admin-panel {
    min-width: 0;
}

.super-admin-card {
    overflow: hidden;
}

.super-admin-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.75rem;
    padding: 1.05rem 1.15rem;
    border-bottom: 1px solid #ebeff5;
    background: linear-gradient(105deg, #fff 45%, #f7faff 100%);
}

.super-admin-heading {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    min-width: 0;
}

.super-admin-icon {
    display: flex;
    flex: 0 0 40px;
    align-items: center;
    justify-content: center;
    height: 40px;
    border-radius: 12px;
    background: #e9f1ff;
    color: #2860ac;
}

.super-admin-icon svg {
    width: 20px;
    height: 20px;
}

.super-admin-heading h2 {
    margin: 0;
    color: #182439;
    font-size: 1.04rem;
    font-weight: 700;
    line-height: 1.3;
}

.super-admin-heading p {
    margin: 0.1rem 0 0;
    color: #7a8699;
    font-size: 0.78rem;
}

.super-admin-access {
    padding: 0.3rem 0.55rem;
    border: 1px solid #dfe9f6;
    border-radius: 99px;
    background: #f4f8ff;
    color: #6f8098;
    font-size: 0.69rem;
    font-weight: 600;
}

.super-admin-fields {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.7rem;
    padding: 1.15rem;
}

.super-admin-field {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    min-width: 0;
    padding: 0.85rem 0.8rem;
    border: 1px solid #edf1f6;
    border-radius: 11px;
    background: #f9fbfd;
}

.super-admin-label {
    color: #8593a5;
    font-size: 0.72rem;
    font-weight: 600;
    line-height: 1.3;
}

.super-admin-value {
    color: #2b405c;
    font-size: 0.86rem;
    font-weight: 680;
    line-height: 1.45;
    overflow-wrap: anywhere;
}

.super-admin-actions {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.6rem;
    padding: 0 1.15rem 1.15rem;
}

.super-admin-actions a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.35rem;
    min-height: 43px;
    padding: 0.65rem 0.72rem;
    border: 1px solid #dce8f7;
    border-radius: 10px;
    background: #f7faff;
    color: #2b65b1;
    font-size: 0.79rem;
    font-weight: 650;
    line-height: 1.35;
    text-decoration: none;
    transition: background 0.15s, border-color 0.15s;
}

.super-admin-actions a:hover {
    border-color: #b6cfee;
    background: #edf5ff;
}

.super-admin-actions a span {
    flex-shrink: 0;
    font-size: 1rem;
}

@media (max-width: 650px) {
    .super-admin-fields {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .super-admin-actions {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 420px) {
    .super-admin-header,
    .super-admin-fields {
        padding: 0.9rem;
    }

    .super-admin-fields {
        grid-template-columns: minmax(0, 1fr);
    }

    .super-admin-actions {
        padding: 0 0.9rem 0.9rem;
    }
}
</style>
